import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import React from "react";

const BackHeaderContainer = styled.header<{
  transparent?: boolean;
  underline?: boolean;
  rightElement?: React.ReactNode;
}>(({ theme, transparent, underline, rightElement }) => ({
  position: "sticky",
  top: 0,
  zIndex: 1000,
  display: "flex",
  justifyContent: rightElement ? "space-between" : "center",
  alignItems: "center",
  height: "56px",
  padding: "1.6rem",
  backgroundColor: transparent ? "transparent" : theme.color.white,
  borderBottom: underline ? `1px solid ${theme.color.border_gray}` : "none",
}));

const IconBox = styled.button({
  position: "absolute",
  left: "1.6rem",
});

const CloseIconBox = styled.button({
  position: "absolute",
  right: "1.6rem",
});

const Title = styled.span(({ theme }) => ({
  color: theme.color.black,
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
}));

type Props = {
  title: string;
  onClick?: () => void;
  transparent?: boolean;
  closeIcon?: boolean;
  underline?: boolean;
  myPage?: boolean;
  children?: React.ReactNode;
  router?: string;
  rightElement?: React.ReactNode;
};
export default function BackHeader({
  title,
  onClick,
  closeIcon,
  transparent,
  underline,
  children,
  router,
  rightElement,
}: Props) {
  const theme = useTheme();
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(-1);
  };

  const handleNavigateHome = () => {
    if (router) {
      navigate(router);
    } else navigate("/");
  };

  return (
    <BackHeaderContainer
      transparent={transparent}
      underline={underline}
      rightElement={rightElement}>
      <IconBox onClick={onClick ? onClick : navigateBack} type="button">
        <Image
          src={
            transparent
              ? theme.image.arrow_left_white.default
              : theme.image.arrow_left.default
          }
          width="2rem"
          height="2rem"
        />
      </IconBox>

      <Title>{title}</Title>

      {children}

      {closeIcon && (
        <CloseIconBox onClick={handleNavigateHome} type="button">
          <Image src={theme.image.close.default} width="2rem" height="2rem" />
        </CloseIconBox>
      )}
    </BackHeaderContainer>
  );
}
